import { AuthUserProfile } from '../../store/Auth/authTypes';

export const checkIsGuardValidation = (profile: AuthUserProfile): boolean => {
  return (
    profile.role === 'guard' ||
    profile.email === 'dalpak1@ashtrom.co.il' ||
    profile.email === 'bakaralyfe@gmail.com'
  );
};

export const checkSuperAdminValidation = (
  profile: AuthUserProfile
): boolean => {
  return profile.email === 'compie-qa@mailinator.com';
};

export const checkCompanyOwnerValidation = (
  profile: AuthUserProfile
): boolean => {
  return Boolean(profile.companyAdmin);
};
